/*
    Manager.js - Manager model
 */

import {Rest} from '@/paks/vu-app'

export default new Rest(
    'Manager',
    {
        getSignedUrl: {method: 'POST', uri: '/:controller/getSignedUrl'},
        provision: {method: 'POST', uri: '/:controller/provision'},
        updateDisplay: {method: 'POST', uri: '/:controller/updateDisplay'},
    },
)
